<script setup lang="ts">
import { Loader2 as Loader2Icon } from '@lucide/vue'
import { computed } from 'vue'

import type { ActionMenuDensity, ActionMenuItem } from './actionMenu'

defineOptions({ name: 'ActionMenuList' })

const props = withDefaults(
  defineProps<{
    items: ActionMenuItem[]
    density?: ActionMenuDensity
  }>(),
  { density: 'comfortable' },
)

const rowClass = computed(() =>
  props.density === 'compact'
    ? 'flex w-full items-center gap-2.5 px-3 py-2.5 text-left text-base transition-colors'
    : 'flex min-h-12 w-full items-center gap-3 px-4 py-3 text-left transition-colors',
)

const iconClass = computed(() =>
  props.density === 'compact' ? 'h-4 w-4 shrink-0' : 'h-5 w-5 shrink-0',
)

const labelClass = computed(() => (props.density === 'compact' ? 'text-base' : 'text-base'))
</script>

<template>
  <template v-for="item in items" :key="item.key">
    <hr v-if="item.separated" class="mx-4 my-1 border-gray-100" />
    <button
      type="button"
      :class="[
        rowClass,
        item.danger
          ? 'text-red-600 hover:bg-red-50 focus-visible:bg-red-50'
          : 'text-gray-700 hover:bg-black/[0.04] focus-visible:bg-black/[0.04]',
        'focus-visible:outline-none',
      ]"
      @click.stop="item.onSelect"
    >
      <component
        :is="item.icon"
        v-if="item.icon"
        :class="[iconClass, item.iconClass ?? (item.danger ? 'text-red-400' : 'text-gray-400')]"
        :style="item.iconStyle"
      />
      <span :class="[labelClass, item.danger ? 'text-red-600' : 'text-gray-800']">
        {{ item.label }}
      </span>
      <Loader2Icon v-if="item.loading" :class="[iconClass, 'ml-auto animate-spin text-gray-400']" />
    </button>
  </template>
</template>
